import { Button, Icon } from "@lindar-joy/goosicorn-quickies-library";
import styled from "styled-components";

const Overlay = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.95);
    z-index: 200;
    position: absolute;
    justify-content: center;
    align-items: center;
`;

const Dialog = styled.div`
    display: flex;
    width: 343px;
    max-width: calc(100% - 32px);
    padding: 16px;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    border-radius: 16px;
    border: 1px solid var(--neutral-40, rgba(255, 255, 255, 0.4));
    background: rgba(0, 0, 0, 0.95);
`;

const Text = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    text-align: center;
`;

const Title = styled.div`
    font-size: 18px;
    font-weight: 600;
`;

const Body = styled.div`
    font-size: 14px;
    color: var(--neutral-40, rgba(255, 255, 255, 0.7));
`;

const RetryButton = styled(Button)`
    width: 100%;
    justify-content: center;
`;

interface ConnectionErrorProps {
    onRetry: () => void;
}

const ConnectionError: React.FC<ConnectionErrorProps> = ({ onRetry }) => {
    return (
        <Overlay>
            <Dialog>
                <Icon type="warning" size="lg" />
                <Text>
                    <Title>Connection lost</Title>
                    <Body>We couldn't connect to the game server. Please check your connection and try again.</Body>
                </Text>
                <RetryButton size="md" primary={true} text="Retry" onClick={onRetry} />
            </Dialog>
        </Overlay>
    );
};

export default ConnectionError;
